import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/foneorders.com/app/src/app/(landing)/privacy/PrivacyPageContent.tsx");
